export const DISTANCE = {
  SHORT: 1,
  MILE: 2,
  MIDDLE: 3,
  LONG: 4,
};

export const STYLE = {
  NIGE: 1,
  SEN: 2,
  SASI: 3,
  OI: 4,
  OONIGE: 10,
};

export const SURFACE = {
  TURF: 1,
  DIRT: 2,
};
